import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { SelectField } from '@livechat/design-system'
import { css } from '@emotion/react'

const sortFieldCss = css`
  margin-bottom: 0;
  min-width: 192px;

  .lc-select-head {
    padding: 5px 10px;
  }

  .lc-select-body,
  .lc-select-head {
    font-size: 15px;
    line-height: 22px;
  }
`

const Sort = ({ options, onSortChange, value }) => {
  const [selectedValue, setSelectedValue] = useState(value)

  const handleSelect = (value) => {
    setSelectedValue(value)
    onSortChange(value)
  }

  const getItemBody = (item) => {
    if (!item) {
      return null
    }
    return <div data-test={item.name}>{item.name}</div>
  }

  const prepareValues = (values) =>
    values.map(({ LABEL, VALUE }) => ({
      key: VALUE,
      props: {
        name: LABEL,
      },
    }))

  const items = prepareValues(options)

  return (
    <SelectField
      css={sortFieldCss}
      id="application-sort-value"
      items={items}
      onItemSelect={handleSelect}
      getItemBody={getItemBody}
      getSelectedItemBody={getItemBody}
      selected={selectedValue}
      required
    />
  )
}

Sort.propTypes = {
  options: PropTypes.array,
  onSortChange: PropTypes.func,
  value: PropTypes.string,
}

export default Sort
